import React from 'react'
import { FiPlay } from "react-icons/fi";
import Image from '../../../image'
import { VideoThumbWrapper, VideoPoster, VideoVerlay, VideoButton } from './video.stc'

const VideoThumb = ({ poster, title, onClick, layout, is_featured }) => {
	return (
		<VideoThumbWrapper onClick={onClick} layout={layout}>
			<VideoPoster>
				<Image src={poster} alt={title} />
			</VideoPoster>
			{!is_featured && (
				<VideoVerlay>
					<VideoButton>
						<FiPlay />
					</VideoButton>
				</VideoVerlay>
			)}
		</VideoThumbWrapper>
	)
}

export default VideoThumb;